import client from '@/lib/http-client';

const endpoint = 'private-orders';
export const getAdminMonitoring = (params, callback, errCallback) => {
	const url = 'admin/monitoring-private-order';
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const getMonitoringOrder = (params, callback, errCallback) => {
	client.get(endpoint, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const getDataStasts = (params, callback, errCallback) => {
	const url = `${endpoint}/statistic/scoreboard-private-order`;
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const exportDataAdmin = (params, callback, errCallback) => {
	const url = '/admin/monitoring-private-order/export';
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const exportDataOwner = (params, callback, errCallback) => {
	const url = `${endpoint}/export`;
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const updateDataOrder = (id, params, callback, errCallback) => {
	const url = `${endpoint}/update/${id}`;
	client.put(url, params).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const processDataOrder = (id, params, callback, errCallback) => {
	const url = `admin/monitoring-private-order/process-order/${id}`;
	client.put(url, params).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const adminUpdateOrder = (id, params, callback, errCallback) => {
	const url = `admin/monitoring-private-order/update/${id}`;
	client.put(url, params).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};

export const getPrivateProduct = (params, callback, errCallback) => {
	const url = `${endpoint}/product`;
	client.get(url, { params }).then((res) => {
		callback(res);
	}).catch((e) => {
		errCallback(e);
	});
};
